import { Text } from '@chakra-ui/react';

import { useGiftcardsPagesLayoutContent } from 'context/giftcardsPagesLayoutContent';

export const Locked = () => {
  const { statuses } = useGiftcardsPagesLayoutContent();

  const { lockedGiftcardTitle, lockedGiftcardDescription } = statuses;

  return (
    <>
      <Text fontWeight="bold" fontSize="1.25rem" mr="auto">
        {lockedGiftcardTitle}
      </Text>

      <Text
        fontSize="1.25rem"
        whiteSpace="pre-line"
        data-testid="locked-giftcard-description"
      >
        {lockedGiftcardDescription}
      </Text>
    </>
  );
};
